export const TOOLTIP_COLORS = {
  slate200: '#e2e8f0',
  slate400: '#94a3b8',
  slate500: '#64748b',
  slate700: '#334155',
};

export const TOOLTIP_SIZES = {
  fontSize: 12,
  gap: 8,
  padX: 16,
};

export function TooltipCard({ children, minWidth, style, className }) {
  return (
    <div
      className={className}
      style={{
        background: '#ffffff',
        border: `1px solid ${TOOLTIP_COLORS.slate200}`,
        borderRadius: 10,
        padding: `${TOOLTIP_SIZES.gap}px ${TOOLTIP_SIZES.padX}px`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
        display: 'flex',
        flexDirection: 'column',
        gap: TOOLTIP_SIZES.gap,
        ...(minWidth ? { minWidth } : {}),
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function TooltipLine({ color = TOOLTIP_COLORS.slate700, weight = 500, children }) {
  return (
    <p style={{ margin: 0, fontSize: TOOLTIP_SIZES.fontSize, fontWeight: weight, color }}>
      {children}
    </p>
  );
}

const POSITION_CLASSES = {
  top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
  right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  'bottom-right': 'top-full left-0 mt-2',
  'top-left': 'bottom-full left-0 mb-2',
  'top-right': 'bottom-full right-0 mb-2',
};

function HoverTooltip({ position, children }) {
  return (
    <TooltipCard
      className={`invisible group-hover:visible absolute ${POSITION_CLASSES[position]} z-10 whitespace-nowrap pointer-events-none`}
    >
      {children}
    </TooltipCard>
  );
}

export function IconTooltip({ label, children, wrapperClassName = '', position = 'top' }) {
  return (
    <span className={`relative group inline-flex ${wrapperClassName}`}>
      {children}
      {label && (
        <HoverTooltip position={position}>
          <TooltipLine>{label}</TooltipLine>
        </HoverTooltip>
      )}
    </span>
  );
}

export function TruncatedText({ children, tooltip, position = 'bottom-right', className = '' }) {
  const tooltipContent = typeof tooltip === 'string' ? <TooltipLine>{tooltip}</TooltipLine> : tooltip;
  return (
    <span className={`relative group inline-block max-w-full min-w-0 cursor-default ${className}`}>
      <span className="block truncate">{children}</span>
      {tooltipContent && <HoverTooltip position={position}>{tooltipContent}</HoverTooltip>}
    </span>
  );
}
